import styled from "styled-components";

export const ProfileInstrumentDetailContainerStyled = styled.div`
  padding: 20px 0px 40px 0px;
  .product_info_layout {
    margin-bottom: 12px;
    padding-left: 16px;
  }
  .booking_layout {
    margin-bottom: 16px;
    padding: 0 16px;
  }
  .btn_wrap {
    margin: auto;
    width: 100%;
    max-width: 167px;
  }
`;
